import styled from 'styled-components';

export const HeatmapWidgetStyled = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
`;
